(() => {
  const initCommunityEnding = (section) => {
    if (!section || section.dataset.communityEndingReady === 'true') return;

    const track = section.querySelector('[data-community-track]');
    const prevButton = section.querySelector('[data-community-prev]');
    const nextButton = section.querySelector('[data-community-next]');

    if (!track || !prevButton || !nextButton) return;

    section.dataset.communityEndingReady = 'true';

    const getStep = () => {
      const card = track.querySelector('.sm-community-ending__polaroid');
      if (!card) return track.clientWidth * 0.75;

      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0');

      return card.getBoundingClientRect().width + gap;
    };

    const updateButtons = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      prevButton.disabled = track.scrollLeft <= 2;
      nextButton.disabled = track.scrollLeft >= maxScroll - 2;

      const noOverflow = maxScroll <= 2;
      prevButton.hidden = noOverflow;
      nextButton.hidden = noOverflow;
    };

    prevButton.addEventListener('click', () => {
      track.scrollBy({
        left: -getStep(),
        behavior: 'smooth'
      });
    });

    nextButton.addEventListener('click', () => {
      track.scrollBy({
        left: getStep(),
        behavior: 'smooth'
      });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    updateButtons();

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(updateButtons);
      observer.observe(track);
    } else {
      window.addEventListener('resize', updateButtons);
    }
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-community-ending]').forEach(initCommunityEnding);
  };

  document.addEventListener('DOMContentLoaded', () => initAll());

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
